import React from 'react';
import i18n from '../../../i18next';
import { isMobile, isMobileOnly, isIOS } from 'mobile-device-detect';

import ShoppingCartSVG from '../../../pwa-app/components/common/svgComponents/ShoppingCartSVG';

const CartItemsButton = (props) => {

    const totalItemsCount = (orderProducts) => {
        let totalItemsCount = 0;

        orderProducts.map(product => {
            totalItemsCount += product.quantity;
        });

        return totalItemsCount;
    }

    const { type, primaryColor, secondaryColor, primaryFontColor, menuItemsBackground } = props.customerThemes.selectedTheme;
    const iconImageColor = type === 'DARK' ? secondaryColor : primaryColor;
    const { cartItemsContent, cartItemsContentRTL, shoppingCartIconStyle, shoppingCartIconStyleRTL } = styles;
    const isMenuHidden = (props.menus.length > 1) ? false : true;

    const mobileAndAppsCartButtonWithMultipleMenusStyle = {
        width: '18%',
        height: '50px',
        backgroundColor: menuItemsBackground,
        paddingLeft: '15px',
        right: '2px',
        top: '10px'
    };

    /* Single top-level menu: category strip only — keep cart in the bar (same layer as tabs), not absolutely offset into the product list */
    const singleMenuNavCartStyle = {
        width: 52,
        minWidth: 48,
        height: 44,
        maxHeight: 44,
        backgroundColor: menuItemsBackground,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        top: 0,
        right: 0,
        pointerEvents: 'auto',
    };

    const compactNavCartStyle = isMenuHidden
        ? singleMenuNavCartStyle
        : (props.pwaAppRunning || isMobileOnly || isMobile)
            ? mobileAndAppsCartButtonWithMultipleMenusStyle
            : null;
    
    const openCart = (e) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        props.toggleCartModal();
    };

    const iconContent = (
        <>
            <div style={{ paddingTop: 4 }}>
                <ShoppingCartSVG width={33} height={33} fill={iconImageColor} style={props.isArabic ? shoppingCartIconStyleRTL : shoppingCartIconStyle} isCartItemsButton={true} />
            </div>
            <div id="cartItemsIcon" style={ props.isArabic ? { ...cartItemsContentRTL, color: menuItemsBackground, backgroundColor: primaryColor, border: `1px solid ${menuItemsBackground} ` } : { ...cartItemsContent, color: menuItemsBackground, backgroundColor: primaryColor, border: `1px solid ${menuItemsBackground}`}}>
                <div style={{fontSize: '14px', padding: '3px'}} id="cartItemsNumber">{(props.shoppingCart.orderProducts !== undefined && props.shoppingCart.orderProducts !== null) ? `${totalItemsCount(props.shoppingCart.orderProducts)}` : `0`}</div>
            </div>
        </>
    );

    if (isIOS) {
        return (
            <div
                className='cartItemsButton'
                style={compactNavCartStyle || undefined}>
                <div
                    className="bag-icon"
                    onClick={openCart}
                    onTouchEnd={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        openCart(e);
                    }}
                    role="button"
                    aria-label="Cart"
                >
                    {iconContent}
                </div>
            </div>
        );
    }

    return (
        <div
            className='cartItemsButton'
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                props.toggleCartModal();
            }}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchEnd={(e) => e.stopPropagation()}
            style={compactNavCartStyle || undefined}>
            {iconContent}
        </div>
    )
}

export default CartItemsButton;

const styles = {
    loggedUserStyle: {
        padding: 0,
        display: 'flex',
        marginRight: 15
    },
    loggedUserStyleRTL: {
        padding: 0,
        display: 'flex',
        marginLeft: 15
    },
    cartItemsContent: {
        width: '27px',
        height: '27px', 
        position: 'absolute',
        top: '0',
        textAlign: 'center',
        fontSize: '1.0625rem',
        borderRadius: '50%',
        alignItems: 'center'
    },
    cartItemsContentRTL: { 
        width: '27px',
        height: '27px', 
        position: 'absolute',
        top: '0',
        textAlign: 'center',
        fontSize: '1.0625rem',
        borderRadius: '50%',
        alignItems: 'center'
    },
    shoppingCartIconStyle: {
        height: 'auto',
        position: 'relative',
        left: 12,
        top: 6
    },
    shoppingCartIconStyleRTL: {
        height: 'auto',
        position: 'relative',
        right: 12,
        top: 6,
        left: 0
    },
}